import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { firebaseApp } from './firebase'; 
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const appCheckSiteKey = process.env.REACT_APP_APP_CHECK_SITE_KEY;

if (appCheckSiteKey) {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(appCheckSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  // Allow dev to run without crashing; remind to set up App Check in production.
  console.warn('App Check site key missing. Set REACT_APP_APP_CHECK_SITE_KEY in .env.local to enable App Check.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
